'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002492 from "./presto.-Two-Factor-Auth-View$$anon$92.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002494 from "./presto.-Two-Factor-Auth-View$$anon$94.js";
import * as $j_presto$002etypes$0024$002dSelected$002dCredential$0024 from "./presto.types$-Selected-Credential$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$91() {
  this.bJ5 = null;
  this.bIX = null;
  this.bIY = false;
  this.bJ6 = null;
  this.bJ7 = false;
  this.bJa = null;
  this.bJ3 = null;
  this.bJ4 = false;
  this.bIZ = null;
  this.bJ0 = false;
  this.bJ1 = null;
  this.bJ2 = false;
  this.bJ8 = false;
  this.bJ9 = false;
  this.bJ5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bJa = "SelectedCredential";
}
export { $c_Lpresto_TwoFactorAuthView$$anon$91 as $c_Lpresto_TwoFactorAuthView$$anon$91 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$91.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$91;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$91() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$91 as $h_Lpresto_TwoFactorAuthView$$anon$91 };
$h_Lpresto_TwoFactorAuthView$$anon$91.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bJ5;
});
$p.L = (function() {
  if ((!this.bIY)) {
    this.bIX = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bIY = true;
  }
  return this.bIX;
});
$p.O = (function() {
  if ((!this.bJ7)) {
    this.bJ6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bJ7 = true;
  }
  return this.bJ6;
});
$p.E = (function() {
  return this.bJa;
});
$p.t = (function() {
  if ((!this.bJ4)) {
    this.bJ3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("credential", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("selected", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bJ4 = true;
  }
  return this.bJ3;
});
$p.M = (function() {
  if ((!this.bJ0)) {
    this.bIZ = ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002492.$c_Lpresto_TwoFactorAuthView$$anon$92(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().ar, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bJ0 = true;
  }
  return this.bIZ;
});
$p.Q = (function() {
  if ((!this.bJ2)) {
    this.bJ1 = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002494.$c_Lpresto_TwoFactorAuthView$$anon$94();
    this.bJ2 = true;
  }
  return this.bJ1;
});
$p.w = (function() {
  if ((!this.bJ9)) {
    this.bJ8 = false;
    this.bJ9 = true;
  }
  return this.bJ8;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee1023) => ((p) => \u03b4scrutinee1023.cGE(p)))($j_presto$002etypes$0024$002dSelected$002dCredential$0024.$m_Lpresto_types$SelectedCredential$())));
});
var $d_Lpresto_TwoFactorAuthView$$anon$91 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$91, "presto.TwoFactorAuthView$$anon$91", ({
  Tw: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$91 as $d_Lpresto_TwoFactorAuthView$$anon$91 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$91.js.map
